exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header_1_Urt {\n    width: 100%;\n}\n\n.divContainerTwo_-uRjP {\n    display: table;\n    width: 100%;\n}\n\n.columnTwo_3vYjb,\n.column_1_two_22ipm {\n    display: table-cell;\n    vertical-align: middle;\n}\n.columnTwo_3vYjb {\n    width: 5%;\n}\n\n.column_1_two_22ipm {\n    width: auto;\n}\n\n.column_1_two_22ipm p {\n    margin: 0 0 2px;\n}\n", ""]);

// exports
exports.locals = {
	"header": "header_1_Urt",
	"divContainerTwo": "divContainerTwo_-uRjP",
	"columnTwo": "columnTwo_3vYjb",
	"column_1_two": "column_1_two_22ipm"
};